import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  class: "pb-4"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("strong", { class: "mb-2" }, "Manual", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TranscriptionComponent = _resolveComponent("TranscriptionComponent")!
  const _component_WorkerRunSummaryComponent = _resolveComponent("WorkerRunSummaryComponent")!

  return (_ctx.transcriptions[_ctx.element.id])
    ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
        (_ctx.manualTranscriptions.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.manualTranscriptions, (transcription) => {
                return (_openBlock(), _createBlock(_component_TranscriptionComponent, {
                  key: transcription.id,
                  element: _ctx.element,
                  transcription: transcription
                }, null, 8, ["element", "transcription"]))
              }), 128))
            ]))
          : _createCommentVNode("", true),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workerRunTranscriptions, ([workerRunId, transcriptions]) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "pb-4",
            key: workerRunId
          }, [
            _createVNode(_component_WorkerRunSummaryComponent, {
              class: "mb-2",
              "worker-run-details": _ctx.workerRunSummaries[workerRunId]
            }, null, 8, ["worker-run-details"]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transcriptions, (transcription) => {
              return (_openBlock(), _createBlock(_component_TranscriptionComponent, {
                key: transcription.id,
                element: _ctx.element,
                transcription: transcription
              }, null, 8, ["element", "transcription"]))
            }), 128))
          ]))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}